import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, finalize, throwError } from 'rxjs';
import { NotifyService } from './core/services/notify.service';
import { LoaderService } from './core/services/loader.service';

@Injectable()
export class AppInterceptorInterceptor implements HttpInterceptor {
  constructor(readonly loader: LoaderService, readonly notifyService: NotifyService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludedUrls = [
      'application-configuration',
      'openid-configuration',
      'profile-picture',
      'check-user-info',
      'token',
      'NIPRSetting',
      'top-notification',
      'e-dEstatus'
    ];
    const shouldShowLoader = !excludedUrls.some(url => request.url.includes(url));
    if (request.url.startsWith('https://api.addresszen.com')) {
      if (request.headers.has('__tenant')) {
        request = request.clone({ headers: request.headers.delete('__tenant') });
      }
    }
    if (shouldShowLoader) {
      this.loader.increment();
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const silentErrorUrls = [
          "openid-configuration",
          "token",
          "connect/token",
        ];
        const shouldHidePopup = silentErrorUrls.some((url) =>
          request.url.includes(url)
        );
        if (!shouldHidePopup && error) {
          this.notifyService.alertpopover({ text: error.error.error?.message, header: error.error.error?.details, type: 2, isCancelButton: false })
        }
        return throwError(() => error);
      }),
      finalize(() => {
        if (shouldShowLoader) {
          this.loader.decrement();
        }
      })
    );
  }
}